const actions = {
  SET_STATE: 'loyalty/SET_STATE',
  GET_LOYALTY: 'loyalty/GET_LOYALTY',
  UPDATE_LOYALTY: 'loyalty/UPDATE_LOYALTY',
}

export default actions
